(function() {
  'use strict';

  function normalize(value) {
    return (value || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function headingKind(node) {
    if (!node || node.nodeType !== 1) return null;
    var tagName = node.tagName.toLowerCase();
    var headingText = '';

    if (/^h[1-6]$/.test(tagName)) {
      headingText = normalize(node.textContent);
    } else if (tagName === 'p' || tagName === 'div' || tagName === 'li') {
      var emphasis = node.children.length === 1 ? node.children[0] : null;
      if (emphasis && /^(strong|b)$/i.test(emphasis.tagName) && normalize(node.textContent) === normalize(emphasis.textContent)) {
        headingText = normalize(emphasis.textContent);
      }
    }

    if (!headingText) return null;
    if (/^(faq|faqs|frequently asked question|frequently asked questions|common questions|questions and answers?)$/.test(headingText)) {
      return 'faq';
    }
    if (/^(product |technical |key )?(specs?|specifications?)$/.test(headingText)) {
      return 'specifications';
    }
    return null;
  }

  function isQuestionHeading(node) {
    if (!node || node.nodeType !== 1 || !/^h[2-5]$/i.test(node.tagName)) return false;
    var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
    return text.length > 0 && text.length <= 160 && /\?\s*$/.test(text);
  }

  function likelySpecificationsTable(table) {
    if (!table || table.nodeType !== 1 || table.tagName.toLowerCase() !== 'table') return false;
    if (table.matches('[data-comparison], .comparison, .comparison-table, [class*="comparison"]')) return false;

    var rows = Array.prototype.slice.call(table.querySelectorAll('tr'));
    if (rows.length < 3) return false;

    var cellsByRow = rows.map(function(row) {
      return Array.prototype.slice.call(row.querySelectorAll(':scope > th, :scope > td'));
    });
    var counts = cellsByRow.map(function(cells) {
      return cells.reduce(function(total, cell) {
        var span = Number(cell.getAttribute('colspan')) || 1;
        return total + span;
      }, 0);
    });

    var firstRowText = normalize(rows[0].textContent);
    if (/compare|comparison/.test(firstRowText)) return false;

    var labels = rows.slice(1).map(function(row) {
      var cell = row.querySelector(':scope > th, :scope > td');
      return (cell ? cell.textContent : '').replace(/\s+/g, ' ').trim();
    });

    var labelsLookLikeSpecifications = labels.every(function(label) {
      return label.length > 0 && label.length <= 60 && !/[?]/.test(label);
    });
    if (!labelsLookLikeSpecifications) return false;

    if (counts.every(function(count) { return count === 2; })) return true;

    var firstHeaderCell = cellsByRow[0][0];
    var firstHeader = normalize(firstHeaderCell ? firstHeaderCell.textContent : '');
    var hasConsistentMultiColumnLayout = counts[0] >= 3 && counts.every(function(count) {
      return count === counts[0];
    });
    if (!hasConsistentMultiColumnLayout) return false;
    if (/^(technical )?specifications?$/.test(firstHeader)) return true;

    var hasBlankTopLeftHeader = firstHeader === '';
    var hasHeaderLabels = rows.slice(1).every(function(row) {
      return row.querySelector(':scope > th') === row.querySelector(':scope > th, :scope > td');
    });
    var technicalLabelCount = labels.filter(function(label) {
      return /\b(weight|width|depth|height|length|dimension|dimensions|capacity|range|speed|battery|motor|seat|wheel|turning|clearance|operation|material|size|sizes|measurement|measurements)\b/i.test(label);
    }).length;

    return hasBlankTopLeftHeader && hasHeaderLabels && labels.length >= 3 && technicalLabelCount >= 2;
  }

  function likelyComparisonTable(table) {
    if (!table || table.nodeType !== 1 || table.tagName.toLowerCase() !== 'table') return false;
    if (table.matches('[data-comparison], .comparison, .comparison-table, [class*="comparison"]')) return true;

    var rows = Array.prototype.slice.call(table.querySelectorAll('tr'));
    if (rows.length < 2) return false;

    return rows.some(function(row) {
      return row.querySelectorAll(':scope > th, :scope > td').length > 2;
    });
  }

  function createSection(kind, label) {
    var detail = document.createElement('details');
    detail.className = 'product__accordion-row product-information-hybrid__section product-information-hybrid__section--' + kind;
    detail.setAttribute('data-hybrid-section', kind);
    detail.setAttribute('data-hybrid-generated', '');
    detail.open = true;

    var summary = document.createElement('summary');
    summary.className = 'product__accordion-summary';
    summary.setAttribute('data-hybrid-summary', '');

    var title = document.createElement('span');
    title.className = 'product__accordion-title';
    title.textContent = label;

    var icon = document.createElement('span');
    icon.className = 'product__accordion-icon';
    icon.setAttribute('aria-hidden', 'true');

    summary.appendChild(title);
    summary.appendChild(icon);

    var content = document.createElement('div');
    content.className = 'product__accordion-content product-information-hybrid__section-content rte';
    content.setAttribute('data-hybrid-generated-content', '');

    detail.appendChild(summary);
    detail.appendChild(content);

    return { detail: detail, content: content };
  }

  function setSectionId(section, root, kind, index) {
    if (!section.id) {
      section.id = 'ProductSection-' + kind + '-' + (root.getAttribute('data-product-section-id') || index);
    }
  }

  function enhanceDescription(root, overview) {
    var description = overview.querySelector('[data-hybrid-description]');
    if (!description) return;

    var nodes = Array.prototype.slice.call(description.childNodes);
    var starts = [];

    nodes.forEach(function(node, index) {
      var kind = headingKind(node);
      if (kind && !starts.some(function(start) { return start.kind === kind; })) {
        starts.push({ index: index, kind: kind, node: node });
      }
    });

    var faqStart = starts.find(function(start) { return start.kind === 'faq'; });
    if (!faqStart) {
      var questionIndexes = nodes.map(function(node, index) {
        return isQuestionHeading(node) ? index : -1;
      }).filter(function(index) { return index !== -1; });

      if (questionIndexes.length >= 2) {
        starts.push({ index: questionIndexes[0], kind: 'faq', node: nodes[questionIndexes[0]] });
      }
    }

    starts.sort(function(a, b) { return a.index - b.index; });

    var specsSection = null;
    var faqSection = null;
    var tableCandidate = null;
    var ambiguousTableCandidate = null;

    nodes.some(function(node) {
      if (node.nodeType !== 1) return false;
      if (node.tagName.toLowerCase() === 'table' && likelySpecificationsTable(node)) {
        tableCandidate = node;
        return true;
      }
      if (
        node.children.length === 1 &&
        node.children[0].tagName.toLowerCase() === 'table'
      ) {
        if (likelySpecificationsTable(node.children[0])) {
          tableCandidate = node;
          return true;
        }
        if (likelyComparisonTable(node.children[0])) {
          ambiguousTableCandidate = node;
          return false;
        }
      }
      if (likelyComparisonTable(node)) {
        ambiguousTableCandidate = node;
        return false;
      }
      return false;
    });

    starts.forEach(function(start, startIndex) {
      var next = starts[startIndex + 1];
      var target;

      if (start.kind === 'specifications') {
        if (!specsSection) specsSection = createSection('specifications', 'Specifications');
        target = specsSection;
      } else if (start.kind === 'faq') {
        if (!faqSection) faqSection = createSection('faq', 'FAQ');
        target = faqSection;
      }

      if (!target) return;

      var endIndex = next ? next.index : nodes.length;
      for (var index = start.index; index < endIndex; index += 1) {
        var node = nodes[index];
        if (node.nodeType === 1 && headingKind(node) === start.kind) {
          node.setAttribute('data-hybrid-source-heading', '');
        }
        target.content.appendChild(node);
      }
    });

    if (!specsSection && tableCandidate) {
      specsSection = createSection('specifications', 'Specifications');
      specsSection.content.appendChild(tableCandidate);
    }

    if (!specsSection && faqSection && ambiguousTableCandidate) {
      overview.querySelector('[data-hybrid-description]').appendChild(ambiguousTableCandidate);
    }

    if (specsSection) {
      overview.parentElement.insertBefore(specsSection.detail, overview.nextSibling);
    }
    if (faqSection) {
      var reference = specsSection ? specsSection.detail : overview;
      reference.parentElement.insertBefore(faqSection.detail, reference.nextSibling);
    }
  }

  function sectionLabel(section) {
    var key = section.getAttribute('data-hybrid-section');
    var explicit = section.getAttribute('data-hybrid-nav-label');
    if (explicit) return explicit;
    var labels = {
      overview: 'Overview',
      specifications: 'Specifications',
      delivery: 'Delivery & Setup',
      finance: 'Finance',
      faq: 'FAQ',
      support: 'AA Mobility Care'
    };
    return labels[key] || (section.querySelector('.product__accordion-title') || {}).textContent || '';
  }

  function orderValue(section) {
    var order = {
      overview: 10,
      specifications: 20,
      delivery: 30,
      finance: 40,
      faq: 50,
      support: 60
    };
    return order[section.getAttribute('data-hybrid-section')] || 70;
  }

  function updateNavigationMetrics(root, nav) {
    var headerOffset = 0;
    Array.prototype.slice.call(document.querySelectorAll('#shopify-section-header, sticky-header, .header-wrapper, header')).forEach(function(header) {
      var rect = header.getBoundingClientRect();
      if (rect.top <= 4 && rect.bottom > 0) {
        headerOffset = Math.max(headerOffset, rect.bottom);
      }
    });
    root.style.setProperty('--product-section-nav-offset', Math.ceil(headerOffset) + 'px');
    root.style.setProperty('--product-section-nav-height', Math.ceil(nav.getBoundingClientRect().height) + 'px');
  }

  function configureNavigation(root, nav, navItems) {
    var links = Array.prototype.slice.call(nav.querySelectorAll('[data-hybrid-nav-link]'));
    var ticking = false;

    function setActive(section) {
      links.forEach(function(link) {
        var active = link.getAttribute('data-hybrid-nav-link') === section.id;
        link.classList.toggle('is-active', active);
        if (active) {
          link.setAttribute('aria-current', 'location');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }

    function refresh() {
      ticking = false;
      updateNavigationMetrics(root, nav);
      var threshold = nav.getBoundingClientRect().bottom + 24;
      var active = navItems[0];
      navItems.forEach(function(section) {
        if (section.getBoundingClientRect().top <= threshold) active = section;
      });
      setActive(active);
    }

    function scheduleRefresh() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(refresh);
    }

    function prepareSection(target) {
      if (window.matchMedia('(min-width: 750px)').matches) {
        navItems.forEach(function(section) {
          section.open = true;
        });
      } else {
        navItems.forEach(function(section) {
          section.open = section === target;
        });
      }
      target.getBoundingClientRect();
    }

    function scrollToSection(target) {
      window.requestAnimationFrame(function() {
        updateNavigationMetrics(root, nav);
        var headerOffset = parseFloat(window.getComputedStyle(root).getPropertyValue('--product-section-nav-offset')) || 0;
        var top = window.pageYOffset + target.getBoundingClientRect().top - headerOffset - nav.getBoundingClientRect().height - 16;
        window.scrollTo({ top: Math.max(0, Math.round(top)), behavior: 'auto' });
        window.requestAnimationFrame(function() {
          if (!window.matchMedia('(min-width: 750px)').matches) {
            var targetTop = target.getBoundingClientRect().top;
            var requiredTop = nav.getBoundingClientRect().bottom + 16;
            if (targetTop < requiredTop) {
              window.scrollBy({ top: Math.round(targetTop - requiredTop), behavior: 'auto' });
            }
          }
          scheduleRefresh();
        });
      });
    }

    links.forEach(function(link) {
      link.addEventListener('click', function(event) {
        var target = document.getElementById(link.getAttribute('data-hybrid-nav-link'));
        if (!target) return;

        event.preventDefault();
        prepareSection(target);
        setActive(target);
        window.history.replaceState(null, '', '#' + target.id);
        scrollToSection(target);
      });
    });

    window.addEventListener('scroll', scheduleRefresh, { passive: true });
    window.addEventListener('resize', scheduleRefresh, { passive: true });
    refresh();
  }

  function enhanceRoot(root) {
    if (root.hasAttribute('data-hybrid-enhanced')) return;

    var group = root.querySelector('[data-product-information-sections]');
    var nav = root.querySelector('[data-product-section-nav]');
    if (!group || !nav) return;

    var overview = group.querySelector('[data-hybrid-section="overview"]');
    if (overview) enhanceDescription(root, overview);

    var sections = Array.prototype.slice.call(group.querySelectorAll(':scope > [data-hybrid-section]'));
    sections.forEach(function(section, index) {
      setSectionId(section, root, section.getAttribute('data-hybrid-section') || 'section', index);
    });

    sections.sort(function(a, b) {
      return orderValue(a) - orderValue(b);
    }).forEach(function(section) {
      group.appendChild(section);
    });

    var navItems = sections.filter(function(section) {
      var key = section.getAttribute('data-hybrid-section');
      return key && !section.hasAttribute('data-hybrid-nav-exclude') && sectionLabel(section);
    });

    var navList = nav.querySelector('.product-section-nav__list');
    if (navList) {
      navItems.forEach(function(section) {
        var item = document.createElement('li');
        var link = document.createElement('a');
        link.href = '#' + section.id;
        link.textContent = sectionLabel(section);
        link.setAttribute('data-hybrid-nav-link', section.id);
        item.appendChild(link);
        navList.appendChild(item);
      });
    }

    root.classList.add('is-enhanced');
    root.setAttribute('data-hybrid-enhanced', '');

    var isDesktopOrTablet = window.matchMedia('(min-width: 750px)');
    function applyResponsiveState() {
      var desktopOrTablet = isDesktopOrTablet.matches;
      sections.forEach(function(section) {
        if (desktopOrTablet) {
          section.open = true;
        } else if (section.getAttribute('data-hybrid-section') !== 'overview') {
          section.open = false;
        }
      });
    }

    applyResponsiveState();
    window.addEventListener('resize', applyResponsiveState, { passive: true });

    if (navItems.length > 1 && navList) {
      nav.setAttribute('data-nav-count', String(navItems.length));
      nav.removeAttribute('hidden');
      configureNavigation(root, nav, navItems);
    }
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-product-information]')).forEach(enhanceRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();

